export interface CountryComplianceDto {
  id: string
  country: {
    id: string
    name: string
  }
  externalRiskLevel: {
    name: string
    id: number
  } | null
  internalRiskLevel: {
    name: string
    id: number
  } | null
  manualScoring: true
  comment: string
  countryComplianceMrloAnalyses: {
    name: string
    id: number
  }[]
  score: number
  tickmillCompany: {
    id: number
    name: string
    shortName: string
  }
}

export enum CountryComplianceDtoKey {
  id = 'id',
  tickmillCompany = 'tickmillCompany',
  country = 'country',
  internalRiskLevel = 'internalRiskLevel',
  score = 'score',
  externalRiskLevel = 'externalRiskLevel',
  manualScoring = 'manualScoring',
  comment = 'comment',
  mRLOAnalysis = 'countryComplianceMrloAnalyses',
}

export interface CountryComplianceTableDto {
  id: string
  country: string
  externalRiskLevel: string | null
  internalRiskLevel: string | null
  manualScoring: boolean
  comment: string
  countryComplianceMrloAnalyses: string
  score: number
  tickmillCompany: string
}

export enum CountryComplianceFilterKey {
  id = 'Id',
  tickmillCompany = 'TickmillCompany',
  country = 'CountryName',
  score = 'Score',
  comment = 'Comment',
  internalRiskLevel = 'InternalRiskLevel',
  externalRiskLevel = 'ExternalRiskLevel',
  mRLOAnalysis = 'MRLOAnalysis',
}
